import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import RoleDeRecouvrementComponent from '../../../components/Mouvement/Panel/RoleDeRecouvrementComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import MouvementPanel from './MouvementPanel';

class RoleDeRecouvrementPanel extends MouvementPanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.ROLE_DE_RECOUVREMENT;
    this.icon = { name: 'bolt' };
  }

  getLibelle = () => 'Rôle de recouvrement';

  isEmpty = (data: Mouvement) => !data?.role;

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <RoleDeRecouvrementComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default RoleDeRecouvrementPanel;
